module.exports = __webpack_public_path__ + "static/media/profile_placeholder_3.6cf3cb43.svg";